var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faXmark, } from '@fortawesome/free-solid-svg-icons';
import InputTooltip from './InputTooltip';
import { mergeHelperAndHint, renderQuestionLabel } from '../../utils/common';
var MAX_DROPDOWN_HEIGHT = 330; // 320px max-h + margins
var DEFAULT_BOTTOM_HEIGHT = 310;
var Searchable = function (_a) {
    var label = _a.label, question = _a.question, questionKey = _a.questionKey, value = _a.value, handleChange = _a.handleChange, handleBlur = _a.handleBlur, placeholder = _a.placeholder, options = _a.options, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.isMulti, isMulti = _c === void 0 ? false : _c, helper = _a.helper, hint = _a.hint, enforceNone = _a.enforceNone;
    var dropdownRef = useRef(null);
    var inputRef = useRef(null);
    var inputSkinWrap = useRef(null);
    var _d = useState(''), inputText = _d[0], setInputText = _d[1];
    var _e = useState(false), showOptions = _e[0], setShowOptions = _e[1];
    var _f = useState(false), alignTop = _f[0], setAlignTop = _f[1];
    var selectHandler = function (opt) {
        var _a;
        if (isMulti) {
            var newValueArray = [];
            if (Array.isArray(value)) {
                newValueArray = __spreadArray([], (value || []), true);
            }
            else if (value) {
                newValueArray.push(value);
            }
            if (enforceNone && opt.value === 'None') {
                newValueArray = ['None'];
            }
            else if (!newValueArray.includes(opt.value)) {
                if (enforceNone) {
                    newValueArray = newValueArray.filter(function (v) { return v !== 'None'; });
                }
                newValueArray.push(opt.value);
            }
            handleChange(newValueArray);
            setInputText('');
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setShowOptions(false);
        }
        else {
            handleChange(opt.value);
            setInputText(opt.caption);
            setShowOptions(false);
        }
    };
    var removeHandler = function (valueToRemove) {
        var _a;
        if (isMulti && Array.isArray(value)) {
            var newValueArray = __spreadArray([], (value || []), true).filter(function (val) { return val !== valueToRemove; });
            handleChange(newValueArray);
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var onElemClick = function (elem) {
        if (isMulti) {
            var clickAbles = [dropdownRef, inputRef, inputSkinWrap];
            if (clickAbles.every(function (c) { return c.current && !c.current.contains(elem); })) {
                setShowOptions(false);
                setInputText('');
            }
        }
    };
    var onBlue = function (e) {
        var _a;
        if (!isMulti && !Array.isArray(value)) {
            // Check if the newly focused element is inside our dropdown
            if (!e.currentTarget.contains(e.relatedTarget)) {
                handleBlur && handleBlur(e);
                setShowOptions(false);
                if (value) {
                    setInputText((_a = options === null || options === void 0 ? void 0 : options.find(function (v) { return v.value == value; })) === null || _a === void 0 ? void 0 : _a.caption);
                }
                else {
                    setInputText('');
                }
            }
        }
    };
    useEffect(function () {
        if (isMulti) {
            var onClickHandler_1 = function (ev) {
                onElemClick(ev.target);
            };
            document.addEventListener('click', onClickHandler_1);
            return function () {
                document.removeEventListener('click', onClickHandler_1);
            };
        }
    }, []);
    useEffect(function () {
        var _a;
        if (!isMulti && !Array.isArray(value)) {
            if (value && !inputText) {
                setInputText((_a = options === null || options === void 0 ? void 0 : options.find(function (v) { return v.value == value; })) === null || _a === void 0 ? void 0 : _a.caption);
            }
            else if (value === '' || value === null || value === undefined) {
                setInputText('');
            }
        }
    }, [value, isMulti, options]);
    useLayoutEffect(function () {
        var parent = document.getElementById('form-parent');
        if (showOptions && inputSkinWrap.current && parent && dropdownRef.current) {
            var elementRect = inputSkinWrap.current.getBoundingClientRect();
            var dropdownRect = dropdownRef.current.getBoundingClientRect();
            var parentRect = parent.getBoundingClientRect();
            var topSpace = elementRect.top - (dropdownRect.height + 4) - parentRect.top;
            var bottomSpace = parentRect.bottom - (elementRect.bottom + dropdownRect.height + 4);
            setAlignTop(!!(topSpace > 0 && bottomSpace < 0));
        }
    }, [showOptions, value, options, inputText]);
    var valueByCaption = useMemo(function () {
        if (isMulti && Array.isArray(value))
            return value === null || value === void 0 ? void 0 : value.map(function (item) {
                return (options === null || options === void 0 ? void 0 : options.find(function (val) { return val.value === item; })) || {
                    caption: item,
                    value: item
                };
            });
    }, [value, options]);
    var availableOptions = isMulti && Array.isArray(value) && value.length
        ? options === null || options === void 0 ? void 0 : options.filter(function (opt) { return !(value === null || value === void 0 ? void 0 : value.includes(opt.value)); })
        : options;
    var filteredOptions = availableOptions === null || availableOptions === void 0 ? void 0 : availableOptions.filter(function (opt) {
        var _a;
        var isSelected = isMulti && Array.isArray(value) ? value === null || value === void 0 ? void 0 : value.includes(opt.value) : false;
        return ((!isSelected && !inputText) ||
            opt.value.toString().toLowerCase().includes(inputText.toLowerCase()) ||
            ((_a = opt.caption) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(inputText.toLowerCase())));
    });
    return (React.createElement("div", { className: "flex flex-col items-start mt-2 w-full h-full justify-end" },
        React.createElement("label", { htmlFor: "".concat(questionKey), className: "text-base md:text-xl flex ".concat(error ? 'text-[#EA4335]' : 'text-[#252846]', " font-medium w-full text-left") },
            renderQuestionLabel(question === null || question === void 0 ? void 0 : question.isHtml, label),
            (helper || hint) && (React.createElement(InputTooltip, { text: mergeHelperAndHint(helper, hint) }))),
        React.createElement("div", { className: "relative w-full mt-2" },
            React.createElement("div", { className: "flex flex-wrap gap-1 w-full px-3 py-2 md:py-2.5 text-[16px] md:text-xl leading-tight border-2 min-h-[52px] md:min-h-[60px] max-h-[160px] overflow-hidden h-fit cursor-text items-baseline ".concat(error
                    ? 'border-[#EA4335] bg-[#FBD9D7] text-[#EA4335] placeholder-[#EA4335]'
                    : 'border-[#E9EDF7] bg-[#F8FAFE] text-[#252846] placeholder-[#b0b7bf]', " rounded-lg md:rounded-xl focus:outline-primary"), onClick: function () {
                    var _a;
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, ref: inputSkinWrap },
                React.createElement("div", { className: "flex flex-wrap gap-1 flex-1 max-w-[calc(100%-30px)] max-h-[130px] overflow-y-auto hide-scrollbar" },
                    isMulti &&
                        valueByCaption &&
                        valueByCaption.map(function (item, i) { return (React.createElement("span", { key: "".concat(item.value, "-").concat(i), className: "h-auto max-h-fit self-center text-sm md:text-base rounded-full bg-slate-400 flex items-center px-[8px] py-0.5 gap-[8px] text-white capitalize cursor-pointer", title: item !== null && item !== undefined ? "".concat(item.caption) : '' },
                            React.createElement("span", { className: "max-w-[150px] md:max-w-[250px] inline-block text-ellipsis overflow-hidden whitespace-nowrap" }, item.caption),
                            React.createElement("button", { type: "button", className: "h-4 w-4 md:h-5 md:w-5 rounded-full bg-slate-500 flex items-center justify-center", onClick: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removeHandler(item.value);
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faXmark, size: "sm" })))); }),
                    React.createElement("input", { name: "".concat(questionKey), id: "".concat(questionKey), type: "text", "aria-autocomplete": "none", autoComplete: "off", onFocus: function () { return setShowOptions(true); }, onBlur: onBlue, onClick: function () { return setShowOptions(true); }, value: inputText, placeholder: placeholder, onChange: function (e) {
                            setInputText(e.target.value);
                            setShowOptions(true);
                        }, ref: inputRef, className: "bg-transparent max-w-full flex-1 outline-none text-[16px] md:text-xl leading-tight text-[#252846] placeholder-[#b0b7bf] max-h-6 py-4" })),
                React.createElement(FontAwesomeIcon, { icon: showOptions ? faChevronUp : faChevronDown, className: "text-gray-400 ml-2" })),
            showOptions && (React.createElement("div", { ref: dropdownRef, style: {
                    maxHeight: MAX_DROPDOWN_HEIGHT - 10,
                    left: 0,
                    right: 0
                }, className: "absolute p-1 bg-[#F8FAFE] rounded-xl border-2 border-[#E9EDF7] overflow-y-auto z-[55] custom-scrollbar ".concat(alignTop
                    ? 'top-[calc(100%+4px)] sm:bottom-[calc(100%+4px)] sm:top-[unset]'
                    : 'top-[calc(100%+4px)]') }, filteredOptions && filteredOptions.length > 0 ? (React.createElement("ul", { className: "flex flex-col" }, filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function (opt) { return (React.createElement("li", { className: "flex-1", key: "".concat(opt.value) },
                React.createElement("button", { className: "flex w-full py-[10px] items-center px-3 h-auto hover:bg-slate-100 rounded-md text-sm md:text-lg font-medium text-left", onMouseDown: function (e) { return !isMulti && e.preventDefault(); }, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        selectHandler(opt);
                    } }, opt.caption))); }))) : (React.createElement("p", { className: "my-4 text-sm md:text-base mx-auto" }, inputText ? 'No results found' : 'No Options')))))));
};
var Select = function (props) {
    var _a;
    return props.searchable ? (React.createElement(Searchable, __assign({}, props, { handleChange: props.handleChangeAutocomplete }))) : (React.createElement("div", { className: "flex flex-col w-full h-full justify-end" },
        React.createElement("label", { htmlFor: "".concat(props.questionKey), className: "flex items-baseline text-sm md:text-xl text-[#252846] font-medium w-full text-left break-words leading-snug" },
            props.label,
            (props.helper || props.hint) && (React.createElement(InputTooltip, { text: mergeHelperAndHint(props.helper, props.hint) }))),
        React.createElement("div", { className: "mt-2 w-full max-w-full" },
            React.createElement("select", { value: props.value || '', name: "".concat(props.questionKey), id: "".concat(props.questionKey), key: props.questionKey, onBlur: props.handleBlur, onChange: props.handleChange, disabled: props.isDisabled, className: "w-full grow basis-full min-w-0 px-3 py-2 md:py-2.5 text-[16px] md:text-xl leading-tight border-2 h-[52px] md:h-[60px] ".concat(props.isDisabled ? 'opacity-60' : '', " ").concat(props.error
                    ? 'border-[#EA4335] bg-[#FBD9D7] text-[#EA4335] placeholder-[#EA4335]'
                    : 'border-[#E9EDF7] bg-[#F8FAFE] text-[#252846] placeholder-[#b0b7bf]', " rounded-lg md:rounded-xl focus:outline-primary") },
                React.createElement("option", { value: "", disabled: true }, props.placeholder || 'Please select an option'), (_a = props.options) === null || _a === void 0 ? void 0 :
                _a.map(function (opt) {
                    return (React.createElement("option", { key: opt.value, value: opt.value }, opt.caption));
                })))));
};
export default Select;
